import React from 'react';
import PropTypes from 'prop-types';
import ComputedNumberField from 'components/field/ComputedNumberField';
import ComputedPriceField from 'components/field/ComputedPriceField';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Label = styled.span`
    margin-left: 5px;
    max-width: 50px;
    font-size: 10px;
    color: ${ theme.palette.silver };

    &:before {
        content: '(';
    }

    &:after {
        content: '${ (props) => {
            const string = props.translate('resources.bookingStats.fields.bookings');

            return string.toLowerCase();
        } })';
        margin-left: 2px;
    }
`;

const AmountAndTotalField = (props) => {
    const { record, source, translate } = props;

    if (utils.isEmpty(record)) {
        return null;
    }

    return (
        <div>
            <Wrapper>
                <ComputedPriceField
                    record={ record[source] }
                    source='total'
                />

                <Label translate={ translate }>
                    <ComputedNumberField
                        record={ record[source] }
                        source='amount'
                    />
                </Label>
            </Wrapper>
        </div>
    );
};

AmountAndTotalField.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(AmountAndTotalField);



// WEBPACK FOOTER //
// ./src/components/field/AmountAndTotalField.js